// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetNewbuildingsCountForSerpRequest,
  TGetNewbuildingsCountForSerpModel,
  IMappers,
  TGetNewbuildingsCountForSerpResponse,
  IGetNewbuildingsCountForSerpResponse,
  IGetNewbuildingsCountForSerpResponseError,
} from './types';

export const defaultConfig: TGetNewbuildingsCountForSerpModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v1/get-newbuildings-count-for-serp/',
  requestType: 'json',
  responseType: 'json',
} as TGetNewbuildingsCountForSerpModel;

export function createGetNewbuildingsCountForSerpModel(
  parameters: IGetNewbuildingsCountForSerpRequest,
): TGetNewbuildingsCountForSerpModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingsCountForSerpOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNewbuildingsCountForSerpRequest;
}

export async function fetchGetNewbuildingsCountForSerp<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsCountForSerpOptions<TResponse200, TResponse400>): Promise<
  TGetNewbuildingsCountForSerpResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetNewbuildingsCountForSerpModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsCountForSerpResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingsCountForSerpResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetNewbuildingsCountForSerpResponse;
}
